import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLocale } from 'src/utils/locale'
import locales from './'

Vue.use(VueI18n)

let locale = getLocale()

const i18n = new VueI18n({
  locale,
  messages: locales
})

export default i18n
